import { SyncDot } from "./SyncDot";
import { SyncIssuesBadge } from "./SyncIssuesBadge";
import { OrgSwitcher } from "./OrgSwitcher";
import { useThemeStore } from "../../store/themeStore";
import { Button } from "../ui/Button";

export function TopBar() {
  const toggle = useThemeStore((s) => s.toggle);
  return (
    <header className="top-bar">
      <div className="brand">Haul Sheet</div>
      <SyncDot />
      <SyncIssuesBadge />
      <div className="spacer" />
      <OrgSwitcher />
      <Button variant="ghost" aria-label="Toggle theme" onClick={toggle}>
        Theme
      </Button>
    </header>
  );
}
